import styled from '@emotion/styled'
import { Grid } from '@mui/material'

export const RoofVisualizationBox = styled(Grid)`
  padding: ${({ theme }) => theme.spacing(0, 3, 3, 3)};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${({ theme }) => theme.spacing(0, 0, 3, 0)};
  }
`
